// config-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Ativar cronologia dos cupons": "Activar cronología de los cupones",
    "Botão de desconto ativado por padrão": "Botón de descuento activado por defecto",
    "Cadastrar senha automática para o cliente(6 primeiros dígitos do CPF)": "Registrar contraseña automática para el cliente (6 primeros dígitos del CPF)",
    "Cadastro de clientes": "Registro de clientes",
    "Cards na Tela Inicial do App": "Tarjetas en la Pantalla Inicial de la Aplicación",
    "Configurações da aba de ofertas": "Configuraciones de la pestaña de ofertas",
    "Considerar tanque cheio (L)": "Considerar tanque lleno (L)",
    "Crie o seu texto de indicação. A palavra \"referral_code\" será substituída pelo código do usuário.": "Cree su texto de referido. La palabra \"referral_code\" será reemplazada por el código del usuario.",
    "Cupons e Ofertas": "Cupones y Ofertas",
    "Destino da Navegação": "Destino de la Navegación",
    "Erro ao iniciar job SGA": "Error al iniciar el job SGA",
    "Esta rede não possui integração com o Firebase configurada. As opções que dependem do Remote Config (cards da home, textos e ajustes do app) ficam indisponíveis até que o arquivo de service account seja cadastrado no cadastro da rede.": "Esta red no tiene integración con Firebase configurada. Las opciones que dependen del Remote Config (tarjetas del inicio, textos y ajustes de la aplicación) quedan indisponibles hasta que el archivo de service account sea registrado en el registro de la red.",
    "Etiqueta padrão seguradora SGA": "Etiqueta predeterminada aseguradora SGA",
    "Execução Manual": "Ejecución Manual",
    "Exibir card apenas para grupos": "Mostrar tarjeta solo para grupos",
    "Exibir preço final apenas para grupos": "Mostrar precio final solo para grupos",
    "Forçar exibição dos descontos no abastecimento": "Forzar visualización de los descuentos en la carga de combustible",
    "Indicação": "Referido",
    "Insistir permissão de notificação": "Insistir en el permiso de notificación",
    "Job SGA iniciado com sucesso!": "¡Job SGA iniciado con éxito!",
    "Login no aplicativo": "Inicio de sesión en la aplicación",
    "Mensagem Inicial": "Mensaje Inicial",
    "Metodo de Navegação": "Método de Navegación",
    "Mostrar Pontuação": "Mostrar Puntuación",
    "Mostrar avaliação do posto": "Mostrar calificación de la estación",
    "Mostrar cashback": "Mostrar cashback",
    "Mostrar desconto por litro": "Mostrar descuento por litro",
    "Mostrar ofertas na tela de cupons": "Mostrar ofertas en la pantalla de cupones",
    "Mostrar preço final em vez do desconto (combustível)": "Mostrar precio final en vez del descuento (combustible)",
    "Máximo de CPFs por dispositivo": "Máximo de CPFs por dispositivo",
    "Máximo de dispositivos por CPF": "Máximo de dispositivos por CPF",
    "Métricas de Combustível": "Métricas de Combustible",
    "Nova Imagem": "Nueva Imagen",
    "Número de Destino": "Número de Destino",
    "Obrigar usuário a avaliar abastecimento": "Obligar al usuario a calificar la carga de combustible",
    "Permitir desassociação de Promoter": "Permitir desasociación de Promoter",
    "Pontuar quando usar desconto": "Puntuar al usar descuento",
    "Posto padrão para vínculo de pontos": "Estación predeterminada para vinculación de puntos",
    "Regras de abastecimento": "Reglas de carga de combustible",
    "Regras de cupons e ofertas": "Reglas de cupones y ofertas",
    "Regulamento": "Reglamento",
    "Regulamento do Número da Sorte": "Reglamento del Número de la Suerte",
    "Resgate somente após um abastecimento": "Canje solo después de una carga de combustible",
    "Saldo em Cashback na Home do app": "Saldo en Cashback en el inicio de la aplicación",
    "Senha SGA": "Contraseña SGA",
    "Senha de acesso à API SGA (Hinova)": "Contraseña de acceso a la API SGA (Hinova)",
    "Site Externo": "Sitio Externo",
    "Solicitar aprovação para abastecimento manual/API": "Solicitar aprobación para carga de combustible manual/API",
    "Solicitar avaliação nas lojas (App Store/Play Store)": "Solicitar calificación en las tiendas (App Store/Play Store)",
    "Tela": "Pantalla",
    "Tela de detalhes do abastecimento": "Pantalla de detalles de la carga de combustible",
    "Tempo para expiração de cupons (dias)": "Tiempo para expiración de cupones (días)",
    "Tempo para expiração de pontos (dias)": "Tiempo para expiración de puntos (días)",
    "Texto de Indicação": "Texto de Referido",
    "Token API SGA": "Token API SGA",
    "Token Mex10": "Token Mex10",
    "Token base de autenticação da API SGA (Hinova)": "Token base de autenticación de la API SGA (Hinova)",
    "URL de Destino": "URL de Destino",
    "Usar data do concentrador nos relatórios": "Usar fecha del concentrador en los reportes",
    "Usar preset no abastecimento": "Usar preset en la carga de combustible",
    "Usuário SGA": "Usuario SGA",
    "Usuário de acesso à API SGA (Hinova)": "Usuario de acceso a la API SGA (Hinova)",
    "Valor do cashback para 1 ponto": "Valor del cashback para 1 punto",
    "Valor para indicado": "Valor para el referido",
    "Valor para quem indica": "Valor para quien refiere",
    "Whatsapp Externo": "WhatsApp Externo",
    "É necessário reabrir o App para visualizar as alterações": "Es necesario reabrir la aplicación para ver los cambios",
};

export default catalogo;
